import { CommonModule } from '@angular/common';
import { Component, DestroyRef, Input, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DocumentationData, DocumentationSection, DocumentationItem } from '../../../../interfaces/necessaryDocumentation.interface';
import { ActivatedRoute } from '@angular/router';

@Component({
	selector: 'app-pymes-documentacion-necesaria',
	standalone: true,
	imports: [
		CommonModule,
		TranslateModule
	],
	templateUrl: './pymes-documentacion-necesaria.component.html',
	styleUrls: ['./pymes-documentacion-necesaria.component.scss']
})
export class PymesDocumentacionNecesariaComponent implements OnInit {
	documentationData: DocumentationData | null = null;

	@Input() data: { canal?: string | number } | null = null;
	canal: string | null = null;
	private translateService = inject(TranslateService);
	private destroyRef = inject(DestroyRef);

	constructor(
		private route: ActivatedRoute
	) { }

	ngOnInit(): void {
		this.readingCanal();
		this.loadDocumentationData();
	}

	private readingCanal() {
		this.canal = this.data?.canal != null
			? String(this.data.canal).replace('.', ',')
			: this.route.snapshot.paramMap.get('canal');
	}

	private loadDocumentationData(): void {
		const textCanal = this.canal === 'CJ' ? 'PYMES.DOCUMENTACION-CONTRATACION-BBSS' : 'PYMES.DOCUMENTACION-CONTRATACION-OTHERS';
		// const textCanal = 'PYMES.DOCUMENTACION-CONTRATACION-OTHERS';
		this.translateService
			.stream(textCanal)
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((data: DocumentationData) => {
				this.documentationData = data;
			});
	}

	trackBySection(index: number, section: DocumentationSection): string {
		return `${section.TITLE}-${index}`;
	}

	trackByItem(index: number, item: DocumentationItem): string {
		return `${item.TEXT}-${index}`;
	}

	trackBySubitem(index: number, subitem: string): string {
		return `${subitem}-${index}`;
	}
}